import React, { useState, useEffect } from 'react';
import { Image as AntdImage, Progress, Tooltip, message } from 'antd';
import { DownCircleOutlined, RightCircleOutlined } from '@ant-design/icons';


import Iconfont from "../../../../components/Iconfont/Iconfont";
import {getSizeText} from '../../../../utils/tool';
import Api from "../../../../api";
import SelfTable from "../../../../components/SelfTable";
import SelfDesignModal from "../../../../components/SelfDesignModal";
import "./index.scss";

const SpaceInfo = ({
    
}) => {
    const colorObject = {
        safe: "#0256FF",
        waring: "#E37318",
        fail: "#ff3a36",
    };

    const [spaceWaringIsShow, setSpaceWaringIsShow] = useState(false); // 空间容量不足提示弹窗
    const [spaceIsShow, setSpaceIsShow] = useState(false); // 空间管理弹窗

    const [spaceInfo, setSpaceInfo] = useState({
        totalStatus: {
            icon: "icon-success",
            tipText: "空间充足",
            usedValue: "0%",
            status: "safe",
        },
        capacityStatus: {
            icon: "icon-success",
            tipText: "空间充足",
            usedValue: "0%",
            status: "safe",
        },
        fileNumStatus: {
            icon: "icon-success",
            tipText: "空间充足",
            usedValue: "0%",
            status: "safe",
        },
        "id": null,
        "userId": "1",
        "otherCapacity": 0,
        "otherNum": 0,
        "initCapacity": 0,
        "initNum": 0,
        "totalCapacity": 0,
        "totalNum": 0,
        "useCapacity": 0,
        "useNum": 0,
    });

    // 分享文档释放空间
    const columns = [
        {
            title: '报告名称',
            dataIndex: 'knowledgeName',
            render: (text) => <a>{text}</a>,
            ellipsis: true,
            align: "left",
        },
        {
            title: '分享状态',
            dataIndex: 'knowledgeCheckStatus',
            width: "120px",
            align: "left",
            render: (text) => (
                <div className="shareStatusBox">
                    {/* knowledge_check_status 0已拒绝，1已通过，2待审批，3草稿文章） */}
                    {
                        text === 0 ? <Tag icon={<Iconfont type={"icon-cuowu"} />} color="error">已拒绝</Tag> :
                            text === 1 ? <Tag icon={<Iconfont type={"icon-dui"} />} color="success">已分享</Tag> :
                                text === 2 ? <Tag icon={<SyncOutlined spin />} color="processing">审批中</Tag> : <Tag icon={<Iconfont type={"icon-yuandian"} iStyle={{top: "-0.1rem", marginRight: "0.1rem"}} />} color="cyan">未分享</Tag>
                    }
                </div>
            ),
        },
        {
            title: '占用空间',
            dataIndex: 'fileSize',
            width: "120px",
            align: "left",
            render: (text, record) => <a>{getSizeText(Number(text || 0), "kb")}</a>,
            ellipsis: true
        },

        {
            title: '操作',
            dataIndex: 'operation',
            width: '120px',
            align: "left",
            render: (_, record) => {
                return (<div className="operateBtnBox"><span className="goShareBth" onClick={() => goShare([record.id])}>去分享</span></div>)
            },
        },];
    const [shareKnowledgeIsShow, setShareKnowledgeIsShow] = useState(false);
    const [unShareKnowledgeList, setUnShareKnowledgeList] = useState([]);
    const [pagination, setPagination] = useState({
        pageSize: 10,
        pageIndex: 1,
        total: 0,
    });
    const [selectedRowKeysObject, setSelectedRowKeysObject] = useState({});

    useEffect(() => {

        getUserSpaceUsedStatus();
    }, []);

    useEffect(() => {
        if (shareKnowledgeIsShow) {
            getUnShareKnowledgeList();
        }
    }, [pagination.pageSize, pagination.pageIndex]);

    // 计算空间信息
    function computedSpaceInfo (rate) {
        let usedRate = rate;

        if (rate > 1) {
            usedRate = 1;
        }

        let spaceInfo = {
            icon: "icon-success",
            tipText: "空间充足",
            usedValue: `${Number(Number(usedRate * 100).toFixed(2))}%`,
            status: "safe",
        };

        if (usedRate >= 1) {
            spaceInfo.icon = "icon-fail";
            spaceInfo.tipText = "空间不足，请分享上传的知识";
            spaceInfo.status = "fail";
        } else if (usedRate >= 0.8) {
            spaceInfo.icon = "icon-tishi";
            spaceInfo.tipText = "空间不足，将影响文档上传";
            spaceInfo.status = "waring";
        }

        return spaceInfo;
    }

    // 获取用户空间使用状态
    const getUserSpaceUsedStatus = async () => {
        const res = await Api.PersonalCenter.getSpaceUsedStatus();
        if (res && res.code == 0) {
            const {
                totalCapacity, totalNum,
                useCapacity, useNum,
            } = res?.data || {};
            let usedRate1 = totalCapacity > 0 ? (useCapacity / totalCapacity) : 1;
            let usedRate2 = totalNum > 0 ? (useNum / totalNum) : 1;
            let rate = usedRate1;
            if(usedRate2 > usedRate1) {
                rate = usedRate2;
            }

            setSpaceInfo({
                totalStatus: computedSpaceInfo(rate || 0),
                capacityStatus: computedSpaceInfo(usedRate1 || 0),
                fileNumStatus: computedSpaceInfo(usedRate2 || 0),
                ...(res?.data || {}),
            });

            if (rate >= 0.8) {
                setSpaceWaringIsShow(true);
            }
        }
    }

    // 获取用户未分享文档列表
    const getUnShareKnowledgeList = async () => {
        const res = await Api.PersonalCenter.getKnowledgeNotPublished({
            data: {
                ...pagination,
                type: 2,
                isCreated: 1,
            },
            // loading: true,
            // loadingText: "数据加载中..."
        });
        if (res && res.code == 0) {
            const {
                records, total,
            } = res?.data || {};
            setUnShareKnowledgeList(records);
            setPagination({
                ...pagination,
                total,
            })
        }
    }

    // 去分享
    const goShare = (ids) => {
        if (ids?.length > 0) {
            if (ids.length > 1) {

            } else {

            }
        } else {
            message.warning("请选择需要分享的知识！");
        }
    }

    // 去分享文件释放空间
    const goRelease = async () => {
        await getUnShareKnowledgeList();
        setSpaceWaringIsShow(false);
        setSpaceIsShow(false);
        setShareKnowledgeIsShow(true);
    }

    
    
    const {totalStatus, capacityStatus, fileNumStatus,} = spaceInfo;
    let rowKeyList = [];
    for (const key in selectedRowKeysObject) {
        rowKeyList.push(...(selectedRowKeysObject[key] || []))
    }

    return(
        <div className="spaceInfoBoxFrameV7">
            {/* 空间使用状态 */}
            <div className={`spaceInfoBox ${totalStatus.status}`}>
                {/* 使用状态 - 数值 */}
                <div className="infoUsedValueBox">
                    <span className="usedValue">空间已使用：{totalStatus.usedValue}</span>
                    <span className="manageBtn" onClick={() => setSpaceIsShow(true)}>查看</span>
                </div>
                {/* 使用状态 - 进度条 */}
                <div className="usedProcessBox">
                    <span className="processBox"><i className="processBar" style={{width: totalStatus.usedValue || 0}}></i></span>
                    <Iconfont type={totalStatus.icon} />
                </div>
                {/* 提示文字 */}
                {
                    totalStatus.tipText ? (<span className="usedTipText">{totalStatus.tipText}</span>) : undefined
                }
            </div>


            {/* 管理空间使用情况 */}
            <SelfDesignModal
                open={spaceIsShow}
                width={"50%"}
                centered={true}
                closeIcon={false}
                closable={false}
                maskClosable={true}
                wrapClassName={"spaceUsedStatusModalBox"}
                onCancel={() => setSpaceIsShow(false)}
                content={(
                    <div className="spaceUsedStatusBox">
                        <div className="spaceUsedHeadBox">
                            <span className="title">空间使用情况</span>
                            {/* <span className="extendBtn" onClick={() => extendFunc()}>去扩容</span> */}
                        </div>
                        <div className="spaceInfoList">
                            <div className="spaceItemBox">
                                <div className="infoBox">
                                    <span className="labelText">存储容量:</span>
                                    <span className="valueText">已使用 {getSizeText(spaceInfo.useCapacity, "mb")}（共 {getSizeText(spaceInfo.totalCapacity, "mb")}）</span>
                                </div>
                                <div className={`usedProcessBox ${capacityStatus.status}`}>
                                    <Tooltip
                                        open={spaceIsShow && capacityStatus.status !== "safe"}
                                        color={"#fff"}
                                        getPopupContainer={() => document.getElementById("capacityProcessBox")}
                                        title={(
                                            <div className="toolTipContentBox">
                                                <Iconfont type={capacityStatus.icon} />
                                                <span className="tipText">空间不足将影响文件上传</span>
                                                <span className="releaseBtn" onClick={() => goRelease()}>立即释放</span>
                                            </div>
                                        )}
                                        placement={"topRight"}
                                    >
                                        <span className="processBox" id={"capacityProcessBox"}>
                                            <i
                                                style={{width: capacityStatus.usedValue || 0}}
                                                className="processBar"
                                            ></i>
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="spaceItemBox">
                                <div className="infoBox">
                                    <span className="labelText">文件数量:</span>
                                    <span className="valueText">已使用 {spaceInfo.useNum} 份（共 {spaceInfo.totalNum} 份）</span>
                                </div>
                                <div className={`usedProcessBox ${fileNumStatus.status}`}>
                                    <Tooltip
                                        open={spaceIsShow && fileNumStatus.status !== "safe"}
                                        color={"#fff"}
                                        getPopupContainer={() => document.getElementById("fileNumProcessBox")}
                                        title={(
                                            <div className="toolTipContentBox">
                                                <Iconfont type={fileNumStatus.icon} />
                                                <span className="tipText">空间不足将影响文件上传</span>
                                                <span className="releaseBtn" onClick={() => goRelease()}>立即释放</span>
                                            </div>
                                        )}
                                        placement={"topRight"}
                                    >
                                        <span className="processBox" id={"fileNumProcessBox"}>
                                            <i
                                                style={{width: fileNumStatus.usedValue || 0}}
                                                className="processBar"
                                            ></i>
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            />

            {/* 空间使用警告弹窗 */}
            <SelfDesignModal
                open={spaceWaringIsShow}
                width={600}
                centered={true}
                maskClosable={false}
                closeIcon={false}
                closable={false}
                wrapClassName={"spaceNotEnoughModalBox"}
                onCancel={() => setSpaceWaringIsShow(false)}
                content={(
                    <div className="spaceNotEnoughBox">
                        <div className={`usedProcessBox ${totalStatus.status}`}>
                            <Progress
                                type="circle"
                                percent={Number(totalStatus.usedValue.replace("%", ""))}
                                strokeColor={colorObject[totalStatus.status] || colorObject.safe}
                                width={70}
                            />
                        </div>
                        <span className="tipTextOne">{totalStatus.status === "fail" ? "个人知识库存储空间已满" : "个人知识库存储空间不足提醒"}</span>
                        <span className="tipTextTwo">将上传的知识发布至公共知识库可释放个人存储空间</span>
                        <div className="btnBox">
                            {
                                totalStatus.status !== "fail" ? (
                                    <span className="operateBtn closeModalBtn" onClick={() => setSpaceWaringIsShow(false)}>下次再说</span>
                                ) : undefined
                            }
                            <span className="operateBtn releaseBtn" onClick={() => goRelease()}>立即分享</span>
                        </div>
                        <div className="bottomTipBox">
                            <span className="tipText">*了解个人知识库存储空间</span>
                            <Tooltip
                                placement="bottomLeft"
                                trigger={"click"}
                                title={(
                                    <div
                                        className="tooltipContentBox"
                                        style={{
                                            width: "7.5rem",
                                            fontSize: "0.5rem",
                                            lineHeight: "1rem",
                                        }}
                                    >
                                        <span style={{display: "block"}}>存储空间上限为 {getSizeText(spaceInfo.totalCapacity, "mb")};</span>
                                        <span>文件数量上限为 {spaceInfo.totalNum} 篇。</span>
                                    </div>
                                )}
                            >
                                <span className="ruleBtn">管理规则</span>
                            </Tooltip>
                        </div>
                    </div>
                )}
            />

            {/* 释放空间弹窗 */}
            <SelfDesignModal
                open={shareKnowledgeIsShow}
                width={1000}
                centered={true}
                maskClosable={false}
                wrapClassName={"shareKnowledgeModalBox"}
                onCancel={() => {
                    setShareKnowledgeIsShow(false);
                    setSelectedRowKeysObject({});
                    setPagination({
                        pageSize: 10,
                        pageIndex: 1,
                        total: 0,
                    })
                }}
                content={
                    (
                        <div className="shareKnowledgeBox">
                            <span className="title">分享文档以释放云空间</span>
                            <div className="infoBox">
                                <span className="infoDesc">共有 {pagination.total} 份文件（限额{spaceInfo.totalNum}份），占用空间 {getSizeText(spaceInfo.useCapacity, "mb")}（限额{getSizeText(spaceInfo.totalCapacity, "mb").replace(" ","")}）</span>
                                <div className={`infoOperateBox ${rowKeyList.length < 1 ? "disabledStatus" : ""}`}>
                                    <span className="selectedNum">已选择 {rowKeyList.length} 项</span>
                                    <span className="cancelSelectBtn" onClick={() => setSelectedRowKeysObject({})}>取消选择</span>
                                    <span className="shareBtn" onClick={() => goShare(rowKeyList)}>批量分享</span>
                                </div>
                            </div>
                            <div className="tableBox">
                                <SelfTable
                                    rowKey="knowledgeId"
                                    bordered={false}
                                    selfRowSelection={{
                                        type: 'checkbox',
                                        selectedRowKeys: selectedRowKeysObject[pagination.pageIndex] || [],
                                        onChange: (newSelectedRowKeys) => {
                                            let newRowKeysObject = {
                                                ...selectedRowKeysObject
                                            };
                                            newRowKeysObject[pagination.pageIndex] = newSelectedRowKeys;
                                            setSelectedRowKeysObject(newRowKeysObject);
                                        },
                                    }}
                                    pagination={{
                                        ...pagination,
                                        showSizeChanger:false,
                                        showQuickJumper:false,
                                        onChange: (currentPage, pageSize) => {
                                            setPagination({
                                                ...pagination,
                                                pageSize,
                                                pageIndex: currentPage,
                                            })
                                        }
                                    }}
                                    dataSource={unShareKnowledgeList}
                                    columns={columns}
                                    expandable={{
                                        expandedRowRender: record => <p style={{margin: 0}}>{record.knowledgeDigest}</p>,
                                        rowExpandable: record => record.knowledgeDigest,
                                        expandIcon: ({expanded, onExpand, record}) =>
                                            expanded ? (
                                                <DownCircleOutlined style={{color: "#1C76FD"}} onClick={e => onExpand(record, e)}/>
                                            ) : (
                                                <RightCircleOutlined style={{color: "#1C76FD"}} onClick={e => onExpand(record, e)}/>
                                            )
                                    }}
                                />
                            </div>
                        </div>
                    )
                }
            />

        </div>
    )
}

export default SpaceInfo;
